import { Link } from 'react-router-dom';
import { difficultyColors } from '@/mocks/articles';

interface ArticleCardProps {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  difficulty: string;
  author: string;
  date: string;
  readTime: string;
  viewCount: number;
  imageUrl: string;
}

export default function ArticleCard({
  title,
  slug,
  excerpt,
  difficulty,
  author,
  date,
  readTime,
  viewCount,
  imageUrl,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-accent-200 transition-all duration-300 cursor-pointer"
    >
      <div className="w-full sm:w-48 h-36 sm:h-auto flex-shrink-0 overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 p-4 md:p-5 flex flex-col justify-between">
        <div>
          <div className="flex items-center gap-2 mb-2 flex-wrap">
            <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${difficultyColors[difficulty]}`}>
              {difficulty}
            </span>
            <span className="text-xs text-foreground-400">{readTime}</span>
          </div>
          <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
            {title}
          </h3>
          <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{excerpt}</p>
        </div>
        <div className="flex items-center justify-between text-xs text-foreground-400 mt-3 pt-3 border-t border-background-100">
          <span>{author} · {date}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line text-xs"></i> {viewCount.toLocaleString()}
          </span>
        </div>
      </div>
    </Link>
  );
}